module.exports = __webpack_public_path__ + "static/BT_cabin_fever-74de7a6016ea33bdb2df5cf408686c7a.png";